
import { Component, Prop, Vue } from "vue-property-decorator";
import { ISolCustomerSupplyMaterialService } from "@/entities";
import SuppliesTable from "@/components/orders/SuppliesTable.vue";

@Component({
  name: "detail-assistance",
  components: {
    SuppliesTable,
  },
})
export default class DetailSupply extends Vue {
  @Prop({ required: true })
  supplyMaterialService!: ISolCustomerSupplyMaterialService | undefined;

  constructor() {
    super();
  }
}
